import React, { useState } from 'react';

import { Tooltip, TooltipProps } from '../../Tooltip';

export interface TruncatedTooltipProps extends Omit<TooltipProps, 'title'> {
  /**
   * The title to display in the tooltip when truncated
   */
  title: React.ReactNode;
  /**
   * The child element that might be truncated
   */
  children: React.ReactElement;
  /**
   * The delay before the tooltip is shown
   * @default 700
   */
  enterDelay?: number;
}

/**
 * A tooltip that only appears if its child element is truncated (overflowing).
 */
export const TruncatedTooltip = ({
  title,
  children,
  id,
  enterDelay = 700,
  placement = 'bottom',
  ...props
}: TruncatedTooltipProps) => {
  const [isTruncated, setIsTruncated] = useState(false);

  const handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
    const element = event.currentTarget;
    const isActuallyTruncated =
      element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
    setIsTruncated(isActuallyTruncated);
  };

  return (
    <Tooltip
      {...props}
      id={id}
      title={isTruncated ? title : ''}
      enterDelay={enterDelay}
      placement={placement}
    >
      {React.cloneElement(children, { onMouseEnter: handleMouseEnter })}
    </Tooltip>
  );
};
